// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "bundle.style.css?" + "1c040af4a08e6026bce0" + "";
};